import Vue from 'vue'
import VueRouter from 'vue-router'
import VueRouterCache from 'vue-router-cache'
import { getToken } from '@/local/user'
import { APP_PATH_LOGIN } from '@/configs/app'
import { isInAppWebview } from '@/utils/bridge'
import Home from '@/views/home/Home.vue'
const Login = () => import('@/views/login/Login.vue')
const MyContestList = () => import('@/views/my-contest/list/MyContestList.vue')
const MyJoinContestList = () => import('@/views/my-contest/list/join/MyJoinContestList.vue')
const MyContestDetail = () => import('@/views/my-contest/detail/MyContestDetail.vue')
const MyContestDraw = () => import('@/views/my-contest/draw/MyContestDraw.vue')
const MyContestPlayerSignUp = () => import('@/views/my-contest/player/sign-up/MyContestPlayerSignUp.vue')
const MyContestPlayerCheckIn = () => import('@/views/my-contest/player/check-in/MyContestPlayerCheckIn.vue')
const MyContestPlayerTeam = () => import('@/views/my-contest/player/team/MyContestPlayerTeam.vue')
const MyContestDrawSetting = ()=> import('@/views/my-contest/draw/setting/MyContestDrawSetting.vue')
const MyContestRefereeCheckIn = () => import('@/views/my-contest/referee/check-in/MyContestRefereeCheckIn.vue')
const MyContestRefereeTeam = () => import('@/views/my-contest/referee/team/MyContestRefereeTeam.vue')
const MyContestZoneSetting = () => import('@/views/my-contest/zone/setting/MyContestZoneSetting.vue')
const ContestInfoLive = () => import('@/views/my-contest/live/ContestInfoLive.vue')
const ContestAreaInfo = () => import('@/views/my-contest/live/area/ContestAreaInfo.vue')
const MyContestLotterySetting = () => import('@/views/my-contest/lottery/setting/MyContestLotterySetting.vue')
const MyContestLotteryHistory = () => import('@/views/my-contest/lottery/history/MyContestLotteryHistory.vue')
const ContestRankInfo = () => import('@/views/my-contest/rank/ContestRankInfo.vue')
const ProxySignUp = () => import('@/views/my-contest/player/proxy-join/ProxySignUp.vue')
const PlayerIgnoreList = () => import('@/views/my-contest/lottery/ignore/PlayerIgnoreList.vue')
const MyContestHelp = () => import('@/views/my-contest/help/MyContestHelp.vue')
const NotFound = () => import('@/views/not-found/NotFound.vue')


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: '主页'
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/my-contests',
        name: 'MyContestList',
        component: MyContestList,
        meta: {
            title: '我发起的比赛',
            authRequired: true
        }
    },
    {
        path: '/my-contests/join',
        name: 'MyJoinContestList',
        component: MyJoinContestList,
        meta: {
            title: '我参加的比赛',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)',
        name: 'MyContestDetail',
        component: MyContestDetail,
        meta: {
            title: '赛事管理',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/player/sign-up',
        name: 'MyContestPlayerSignUp',
        component: MyContestPlayerSignUp,
        meta: {
            title: '运动员现场报名',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/player/check-in',
        name: 'MyContestPlayerCheckIn',
        component: MyContestPlayerCheckIn,
        meta: {
            title: '运动员扫码签到',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/player/team',
        name: 'MyContestPlayerTeam',
        component: MyContestPlayerTeam,
        meta: {
            title: '运动员管理',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/referee/check-in',
        name: 'MyContestRefereeCheckIn',
        component: MyContestRefereeCheckIn,
        meta: {
            title: '裁判扫码签到',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/referee/team',
        name: 'MyContestRefereeTeam',
        component: MyContestRefereeTeam,
        meta: {
            title: '裁判队伍',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/zone/setting',
        name: 'MyContestZoneSetting',
        component: MyContestZoneSetting,
        meta: {
            title: '区位与裁判设置',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/draw/setting',
        name: 'MyContestDrawSetting',
        component: MyContestDrawSetting,
        meta: {
            title: '抽签设置',
            background:'#00000016',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/lottery/setting',
        name: 'MyContestLotterySetting',
        component: MyContestLotterySetting,
        meta: {
            title: '赛后抽奖',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/lottery/ignore',
        name: 'PlayerIgnoreList',
        component: PlayerIgnoreList,
        meta: {
            title: '运动员筛选',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/lottery/history',
        name: 'MyContestLotteryHistory',
        component: MyContestLotteryHistory,
        meta: {
            title: '抽奖记录',
            background:'#00000016',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/live',
        name: 'ContestInfoLive',
        component: ContestInfoLive,
        meta:{
            title: '实时赛事信息',
            background:'#00000016',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/live/area',
        name: 'ContestAreaInfo',
        component: ContestAreaInfo,
        meta:{
            title: '分区成绩',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/rank',
        name: 'ContestRankInfo',
        component: ContestRankInfo,
        meta:{
            title: '排行榜',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/draw',
        name: 'MyContestDraw',
        component: MyContestDraw,
        meta:{
            title: '抽签',
            background: '#00000016',
            authRequired: true
        }
    },
    {
        path: '/my-contests/:contestId(\\d+)/player/join/proxy',
        name:'ProxySignUp',
        component: ProxySignUp,
        meta:{
            title: '代理报名',
            authRequired:true
        }
    },
    {
        path: '/my-contests/help',
        name: 'MyContestHelp',
        component: MyContestHelp,
        meta: {
            title: '帮助文档'
        }
    },
    {
        path: '*',
        name: 'NotFound',
        component: NotFound,
        meta: {
            title: '404'
        }
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.title)) {
        document.title = to.meta.title
    } else {
        document.title = ''
    }

    if (to.matched.some(record => record.meta.background)) {
        document.querySelector('body').setAttribute('style', 'background-color:'+to.meta.background)
    } else {
        document.querySelector('body').setAttribute('style', 'background-color:#ffffff')
    }

    if (to.matched.some(record => record.meta.authRequired)) {
        const token = getToken()
        if (token) {
            next()
        } else {
            if (isInAppWebview()) {
                window.open(APP_PATH_LOGIN)
            } else {

                next({
                    path: '/login',
                    query: {
                        redirect: to.fullPath
                    }
                })
            }
        }
    } else {

        next()
    }
})

Vue.use(VueRouterCache, {
    router,
    max: 10,
    isSingleMode: false,
    getHistoryStack() {
        const str = window.sessionStorage.getItem('historyStack')
        return JSON.parse(str)
    },
    setHistoryStack(history) {
        const str = JSON.stringify(history)
        window.sessionStorage.setItem('historyStack', str)
    }
})

export default router
